var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Login' && _vm.$route.name !== 'SignUp')?_c('div',{attrs:{"id":"navigation"}},[_c('Navigation')],1):_vm._e(),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }